import { z } from 'zod'

export const zProductStockEnum = z.enum([
  'STOCK_REGULAR_WITHOUT_QUANTITY',
  'STOCK_REGULAR_WITH_QUANTITY',
  'NON_STOCK_WITHOUT_QUANTITY',
  'NON_STOCK_WITH_QUANTITY',
  'NON_STOCK_DIRECT_WITH_QUANTITY',
  'UNKNOWN',
])

export type ProductStockEnumSchema = z.infer<typeof zProductStockEnum>

export const ProductStockEnum = zProductStockEnum.enum
